export const DRIVER_MANAGEMENT_ACTIONS = {
  GET_DRIVER: 'DRIVER_MANAGEMENT_ACTIONS.GET_DRIVER',
  GET_TOTAL_COUNT_DRIVER: 'DRIVER_MANAGEMENT_ACTIONS.GET_TOTAL_COUNT_DRIVER',
  SET_IS_DRIVER_DATA_LOADING:
    'DRIVER_MANAGEMENT_ACTIONS.SET_IS_DRIVER_DATA_LOADING',
  SET_FILTERS: 'DRIVER_MANAGEMENT_ACTIONS.SET_FILTERS',
};
